module.exports = __webpack_public_path__ + "img/2015-Partnership-Logo-min.d46438f9.png";